// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button[data-v-114805be] {\n    background-color: #e8e8e1;\n    padding: 10px 20px;\n    color: #333;\n    text-decoration: none;\n    font-size: 14px;\n    cursor: pointer;\n    font-weight: 500;\n    border: solid 1px #CECECE;\n}\n", ""]);
// Exports
module.exports = exports;
